<template>
  <div>
    <q-icon
      class="menu-container"
      name="icon-more-horizontal"
    >
      <q-menu
        square
        class="action-menu"
        content-style="min-width: 240px;"
        anchor="bottom right"
        self="top right"
      >
        <q-list :class="{ disabled: $attrs.disable }">
          <q-item
            v-for="(option, idx) in options"
            :key="idx"
            v-close-popup
            clickable
            @click="selectionChanged(option)"
          >
            <q-item-section
              class="q-item-section"
              data-testid="inline-menu-option"
            >
              <div class="menu-item-row">
                {{ getOptionName(option) }}
              </div>
            </q-item-section>
          </q-item>
        </q-list>
      </q-menu>
    </q-icon>
  </div>
</template>

<script>
import { startCase } from 'lodash';

export default {
  name: 'IbInlineMenu',
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    options: {
      required: true,
    },
  },
  methods: {
    getOptionName(option) {
      return option.name ? option.name : startCase(option.id);
    },
    selectionChanged(option) {
      this.$emit('change', option);
    },
  },
};
</script>

<style lang="scss" scoped>
.menu-container {
  padding: 4px;
  margin: -4px;
  &:hover {
    cursor: pointer;
    background-color: $-hovers-hover-grey;
    border-radius: 50%;
  }
}
.disabled {
  color: $-system-app-grey-76;
  pointer-events: none;
}
:deep(.q-item.q-focusable.q-hoverable:hover) {
  background-color: $-system-app-primary-bg;
  color: $-text-text-primary;
  font-weight: 500;
  font-family: Gordita-Medium;
  transition: 0.3s;
}
</style>
